module.exports = __webpack_public_path__ + "img/c6.a06c6c21.jpg";